import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Zap, Mail, Heart, ExternalLink, Code2, Globe } from 'lucide-react'

const footerLinks = {
  Product: [
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'Profile',   href: '/profile' },
    { label: 'Payment',   href: '/payment' },
  ],
  Company: [
    { label: 'About',   href: '#about' },
    { label: 'Blog',    href: '#blog' },
    { label: 'Careers', href: '#careers' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Terms of Service', href: '#terms' },
    { label: 'Cookie Policy',   href: '#cookies' },
  ],
}

const socialLinks = [
  { icon: Code2,       href: 'https://github.com',         label: 'GitHub' },
  { icon: Globe,       href: 'https://twitter.com',        label: 'Twitter' },
  { icon: ExternalLink,href: 'https://linkedin.com',       label: 'LinkedIn' },
  { icon: Mail,        href: 'mailto:hello@example.com',   label: 'Email' },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-border-subtle bg-surface/50">
      <div className="container-app py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">

          {/* Brand column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 group w-fit">
              <div className="w-8 h-8 rounded-lg bg-gradient-primary flex items-center justify-center shadow-glow-sm">
                <Zap className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-lg text-gradient">Portfolio</span>
            </Link>
            <p className="text-text-muted text-sm leading-relaxed max-w-xs">
              A premium React portfolio scaffold built with Vite, Tailwind CSS,
              and Framer Motion. Fast, accessible, and beautiful by default.
            </p>

            {/* Socials */}
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <motion.a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-9 h-9 rounded-lg glass flex items-center justify-center text-text-muted hover:text-primary-400 hover:border-primary-500/30 transition-colors duration-200"
                >
                  <Icon className="w-4 h-4" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-xs font-semibold uppercase tracking-widest text-text-subtle mb-4">
                {title}
              </h3>
              <ul className="space-y-2.5">
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <Link
                      to={href}
                      className="text-sm text-text-muted hover:text-text transition-colors duration-200"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="divider-gradient mt-12 mb-6" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-text-subtle">
          <p>
            {year} Portfolio. All rights reserved.
          </p>
          <p className="flex items-center gap-1.5">
            Built with <Heart className="w-3 h-3 text-accent inline" /> using React + Vite + Tailwind
          </p>
        </div>
      </div>
    </footer>
  )
}
